import type { Messages } from './en';

/** Estonian UI messages. Prototype draft: needs native-speaker review before any pilot (PROJECT_STATUS K15). */
export const et: Messages = {
  'shell.skipLink': 'Mine sisu juurde',
  'shell.brand': 'Kids World',
  'shell.brandTag': 'Prototüüp',
  'shell.navLabel': 'Peamenüü',
  'shell.menu': 'Menüü',
  'shell.closeMenu': 'Sulge menüü',
  'shell.broadcaster': 'Ringhääling',
  'shell.language': 'Keel',
  'shell.help': 'Abi',
  'shell.disclaimer':
    'Kids World on esialgne kontseptsiooni prototüüp. Kõik näidatud ringhäälingud, saated ja inimesed on väljamõeldud. See ei ole EBU ega selle liikmete teenus ega viita nende toetusele.',
  'shell.helpAndData': 'Abi ja sinu andmed',
  'shell.loading': 'Laadimine…',

  'nav.discover': 'Linn',
  'nav.watch': 'Vaata',
  'nav.play': 'Mängi',
  'nav.create': 'Loo',
  'nav.projects': 'Minu projektid',
  'nav.skills': 'Minu oskused',

  'error.retry': 'Proovi uuesti',
  'error.code': 'Viga {code}.',
  'error.WEB-NAV-001': 'Seda lehte ei leitud. Mine tagasi avastama.',
  'notFound.title': 'Lehte ei leitud',
  'notFound.back': 'Tagasi algusesse',
  'error.generic': 'Meie poolel läks midagi valesti. Proovi hetke pärast uuesti.',
  'error.WEB-API-001': 'Kids Worldiga ei saa praegu ühendust. Kontrolli ühendust ja proovi uuesti.',
  'error.API-DB-001': 'Saateid ei saa praegu laadida. Proovi hetke pärast uuesti.',
  'error.API-RATE-001': 'Korraga on liiga palju päringuid. Oota hetk ja proovi uuesti.',
  'error.CONTENT-CONFIG-001': 'Seda ringhäälingut ei leitud. Vali loendist mõni teine.',
  'error.CONTENT-CATALOGUE-001':
    'Seda saadet valitud ringhäälingu juures ei ole. Vali kataloogist mõni teine saade.',
  'error.WEB-STORAGE-001':
    'See brauser ei saa praegu midagi salvestada. Saad edasi vaadata ja avastada; sinu valikud kehtivad lehe sulgemiseni.',

  'discover.title': 'Avasta',
  'discover.intro': 'Vaata saateid, mängi ja meisterda — sisselogimist pole vaja.',
  'discover.startExploring': 'Alusta avastamist',
  'discover.featured': 'Esile tõstnud {broadcaster}',
  'discover.watch': 'Vaata',
  'discover.noItems': 'Sellel ringhäälingul ei ole praegu ühtegi saadet.',
  'rail.fromBroadcasters': 'Meie ringhäälingutelt',
  'rail.fromBroadcastersNote': 'Valinud ja järjestanud {broadcaster} toimetajad.',
  'rail.playWithStory': 'Mängi looga',
  'rail.playWithStoryNote': 'Saated, millega käib kaasas mäng.',
  'rail.makeSomething': 'Meisterda midagi',
  'rail.makeSomethingNote': 'Saated ehitamisest, meisterdamisest ja katsetamisest.',
  'rail.empty': 'Selle ringhäälingu juures pole siin veel midagi.',
  'rail.previous': 'Näita eelmisi saateid',
  'rail.next': 'Näita rohkem saateid',
  'rail.seeAll': 'Kõik saated',

  'data.title': 'Sinu andmed selles seadmes',
  'data.body':
    'Kids Worldi saab kasutada ilma kontota. Sinu valikud (ringhääling, keel ja soovi korral huvid) ning kõik, mida sa teed, salvestatakse ainult selles brauseris. Meile ei saadeta midagi.',
  'data.warning':
    'Brauserid võivad salvestatud andmeid kustutada, näiteks privaatse sirvimise ajal või saidi andmete tühjendamisel. Ekspordi projektid, mida soovid alles hoida.',
  'data.nothingSaved': 'Selles brauseris ei ole veel midagi salvestatud.',
  'data.savedChoices': 'Sinu valikud on selles brauseris salvestatud.',
  'data.projects.one': '{count} salvestatud projekt',
  'data.projects.other': '{count} salvestatud projekti',
  'data.clear': 'Kustuta minu andmed',
  'data.clearTitle': 'Kas kustutada sinu andmed selles brauseris?',
  'data.clearBody':
    'See eemaldab selles brauseris sinu salvestatud valikud, projektid ja edusammud. Ekspordi enne projektid, mida soovid alles hoida. Seda ei saa tagasi võtta.',
  'data.cancel': 'Tühista',
  'data.cleared': 'Sinu andmed selles brauseris on kustutatud.',

  'card.ages': 'Vanus {min}–{max}',
  'card.minutes': 'Umbes {minutes} min',
  'card.episode': '{season}. hooaeg, {episode}. osa',
  'card.audio': 'Heli: {languages}',
  'card.captions': 'Subtiitrid: {languages}',
  'card.noCaptions': 'Subtiitreid veel pole',
  'card.origin': 'Pärit: {origin}',
  'card.game': 'Mänguga',
  'card.fictional': 'Väljamõeldud näide',
  'card.textLanguage': 'Tekst: {language}',
  'availability.playable': 'Valmis vaatamiseks',
  'availability.media-missing': 'Video pole veel saadaval',
  'availability.not-streamable': 'Ainult loendis, siin ei saa vaadata',
  'availability.rights-not-started': 'Saadaval alates {date}',

  'format.episode': 'Osa',
  'format.short': 'Lühifilm',
  'format.special': 'Erisaade',
  'format.clip': 'Klipp',
  'topic.science': 'Teadus',
  'topic.nature': 'Loodus',
  'topic.stories': 'Lood',
  'topic.making': 'Meisterdamine',
  'topic.music': 'Muusika',
  'topic.sport': 'Sport',
  'topic.history': 'Ajalugu',
  'topic.animals': 'Loomad',
  'warning.mild-peril': 'Kerge oht',
  'warning.loud-noises': 'Valjud helid',
  'warning.flashing-lights': 'Vilkuvad tuled',
  'warning.darkness': 'Pimedad stseenid',
  'credit.production': 'Tootmine',
  'credit.commissioning-member': 'Tellinud liige',
  'credit.creator-collaboration': 'Koostöö sisuloojaga',
  'credit.voice': 'Hääl',
  'credit.music': 'Muusika',

  'watch.title': 'Vaata',
  'watch.intro':
    'Kõik ringhäälingu {broadcaster} saated selles järjekorras, mille valisid toimetajad.',
  'filter.legend': 'Leia saade',
  'filter.search': 'Otsi',
  'filter.searchHint': 'Sõnad pealkirjast või kirjeldusest',
  'filter.topics': 'Huvid',
  'filter.age': 'Vanus',
  'filter.ageAny': 'Iga vanus',
  'filter.format': 'Tüüp',
  'filter.formatAny': 'Iga tüüp',
  'filter.clear': 'Tühjenda filtrid',
  'filter.remember': 'Jäta minu huvid selles brauseris meelde',
  'filter.rememberHint': 'Vabatahtlik. Salvestatakse ainult selles seadmes ja kuhugi ei saadeta.',
  'watch.results.one': '{count} saade',
  'watch.results.other': '{count} saadet',
  'watch.noResults': 'Nende valikutega ei leitud ühtegi saadet.',
  'watch.noResultsHint': 'Proovi vähem huve, teist vanust või teisi sõnu.',

  'programme.back': 'Kõik saated',
  'programme.details': 'Üksikasjad',
  'programme.made': 'Tegija',
  'programme.credits': 'Tegijad',
  'programme.goodToKnow': 'Hea teada',
  'programme.languages': 'Keeled',
  'programme.series': 'Selle sarja osad',
  'programme.thisEpisode': 'See osa',
  'programme.playable': 'Seda saadet tohib siin näidata.',
  'programme.unavailable.media-missing':
    'Selle saate video pole veel saadaval. Saad saate kohta lugeda ja teisi saateid avastada.',
  'programme.unavailable.not-streamable':
    'Seda saadet võib siin loendis näidata, kuid Kids Worldis seda vaadata ei saa.',
  'programme.unavailable.rights-not-started': 'Seda saadet saab vaadata alates {date}.',
  'programme.whatNext': 'Mis edasi?',
  'programme.moreProgrammes': 'Avasta veel saateid',
  'programme.backToDiscover': 'Tagasi linna',

  'place.cinema': 'Kino',
  'place.cinemaNote': 'Vaata toimetajate valitud saateid.',
  'place.lab': 'Avastuslabor',
  'place.labNote': 'Lahenda meie lugude vooluringi-ülesandeid.',
  'place.tower': 'Euroopa gloobus',
  'place.towerNote': 'Vali oma ringhääling ja keel.',
  'place.workshop': 'Meistrite õu',
  'place.workshopNote': 'Ehita asju 3D-s.',
  'place.treehouse': 'Puumaja',
  'place.treehouseNote': 'Sinu projektid ja oskused, salvestatud selles brauseris.',
  'hub.title': 'Kids Worldi linn',
  'hub.welcomeTitle': 'Tere tulemast Kids Worldi',
  'hub.welcomeBody':
    'Avasta linna. Kinos saad vaadata saateid, laboris lahendada vooluringi-ülesandeid, meistrite õuel ehitada ja Euroopa gloobuse juures valida ringhäälingu; puumajas näed oma projekte ja oskusi. Sisselogimist pole vaja.',
  'hub.startExploring': 'Alusta avastamist',
  'hub.placesLabel': 'Kohad linnas',
  'hub.goIn': 'Mine sisse',
  'hub.lookInside': 'Vaata lähemalt',
  'hub.building': 'Ehitamisel',
  'hub.keysHint': 'Nooleklahvid valivad koha. Enter viib sisse.',
  'hub.previousPlace': 'Eelmine koht',
  'hub.nextPlace': 'Järgmine koht',
  'hub.nowShowing': 'Praegu kinos',
  'hub.loading3d': 'Linna ehitatakse…',
  'hub.useMap': 'Lihtne kaart',
  'hub.use3d': '3D-linn',
  'hub.mapTitle': 'Linna kaart',
  'error.WORLD-RENDER-001': 'Sinu brauser ei saa 3D-linna näidata. Lihtne kaart töötab samamoodi.',
  'poster.sample': 'Väljamõeldud näide',
  'data.close': 'Sulge',
  'data.open': 'Minu andmed',
  'cinema.title': 'Kino',
  'cinema.back': 'Tagasi linna',
  'cinema.interests': 'Mis sulle meeldib?',
  'cinema.everything': 'Kõik',
  'cinema.allAges': 'Iga vanus',
  'cinema.allTypes': 'Kõik tüübid',
  'cinema.shelfAll': 'Kõik saated',
  'cinema.shelfGames': 'Lood koos mänguga',
  'cinema.shelfMaking': 'Meisterda ja ehita',
  'cinema.results': 'Saated sinu jaoks',
  'tower.title': 'Euroopa gloobus',
  'tower.intro':
    'Iga ringhääling valib saated oma riigi jaoks. Sinu salvestatud asjad jäävad alles ka siis, kui vahetad.',
  'tower.choose': 'Vali ringhääling',
  'tower.selected': 'Valitud',
  'tower.languages': 'Keeled',
  'hub.canvasLabel':
    '3D-linn. Kõnni klahvidega W A S D või nooltega, vaata ringi lohistades ja vajuta ukse juures Enter, et sisse minna.',
  'hub.pressEnter': 'Oled ukse juures. Vajuta Enter, et sisse minna.',
  'hub.walkHint': 'W A S D või nooled kõndimiseks · lohista vaatamiseks · keri suumimiseks',
  'player.label': 'Videomängija',
  'player.play': 'Esita',
  'player.start': 'Esita saade',
  'player.pause': 'Peata',
  'player.back10': '10 sekundit tagasi',
  'player.forward10': '10 sekundit edasi',
  'player.mute': 'Vaigista',
  'player.unmute': 'Heli sisse',
  'player.volume': 'Helitugevus',
  'player.seek': 'Koht saates',
  'player.time': '{current} / {total}',
  'player.captions': 'Subtiitrid',
  'player.captionsOff': 'Väljas',
  'player.fullscreen': 'Täisekraan',
  'player.exitFullscreen': 'Välju täisekraanist',
  'player.keys':
    'Klahvid: tühik esita või peata · ← → 5 sekundit · ↑ ↓ helitugevus · M vaigista · C subtiitrid · F täisekraan',
  'player.loading': 'Video laadib…',
  'player.watchAgain': 'Vaata uuesti',
  'player.captionsFailed': 'Subtiitreid ei õnnestunud laadida.',
  'player.retry': 'Proovi uuesti',
  'end.title': 'Lõpp. Mis edasi?',
  'end.body': 'Võid siin lõpetada või valida, mida järgmiseks teha.',
  'programme.nextGame': 'Järgmiseks: proovi vooluringi-ülesannet',
  'programme.createWorkshop': 'Loo töökojas',
  'programme.playGame': 'Mängi mängu',
  'card.noSpeech': 'Kõnet pole: muusika ja helid',
  'error.CONTENT-MEDIA-002':
    'Seda videot ei saanud esitada. Proovi uuesti või vali selle asemel mäng või töökoda.',
  'shell.fictionalBar':
    'Prototüüp · kõik saatjad, saated ja inimesed on väljamõeldud · see ei ole EBU ega selle liikme teenus',
  'shell.searchHint': 'Otsi saateid',
  'nav.cinema': 'Kino',
  'nav.lab': 'Labor',
  'nav.workshop': 'Töökoda',
  'nav.myStuff': 'Minu asjad',
  'cinema.featured': 'Esiletõstetud',
  'cinema.featuredGame': 'Esiletõstetud · koos mänguga',
  'cinema.watchNow': 'Vaata kohe',
  'cinema.tryChallenge': 'Proovi ülesannet',
  'cinema.aboutIt': 'Loe lähemalt',
  'cinema.rowAll': 'Kõik {broadcaster} saated',
  'cinema.rowAllNote': 'Toimetajate valitud järjekorras',
  'cinema.rowGames': 'Vaata, siis mängi',
  'cinema.rowGamesNote': 'Lood, millega kaasneb laboris ülesanne',
  'cinema.rowMaking': 'Meisterda ja ehita',
  'cinema.rowMakingNote': 'Saated ehitamisest, meisterdamisest ja katsetamisest',
  'cinema.rowLiked': 'Sest sulle meeldib {topics}',
  'cinema.rowLikedNote': 'Huvide põhjal, mille sa sellesse seadmesse salvestasid',
  'cinema.showAll': 'Näita kõiki',
  'search.title': 'Saated',
  'search.resultsFor': 'Tulemused: „{query}”',
  'search.filters': 'Filtrid',
  'search.topics': 'Huvid',
  'card.thumbFictional': 'Väljamõeldud',
  'programme.crumbs': 'Asukoht',
  'programme.side': 'Osad ja tegevused',
  'programme.seasonTitle': '{season}. hooaeg',
  'programme.itemVideo': 'Video · {duration}',
  'programme.watchingNow': 'Vaatad praegu',
  'programme.challengeItem': 'Ülesanne: {title}',
  'programme.challengeMeta': 'Mäng laboris',
  'programme.buildItem': 'Ehita midagi töökojas',
  'programme.buildMeta': 'Töökoda',
  'programme.stopAnyTime': 'Võid igal ajal lõpetada. Järgmine osa ei hakka ise mängima.',
  'programme.tabOverview': 'Ülevaade',
  'programme.tabLanguages': 'Keeled',
  'programme.tabAbout': 'Teave',
  'programme.learn': 'Mida sa teada saad',
  'objective.closedLoop': 'Lamp põleb ainult siis, kui vooluring on suletud',
  'objective.switchControl': 'Lüliti avab ja sulgeb vooluringi',
  'objective.faultDiagnosis': 'Kuidas leida katkises vooluringis vahe',
  'objective.sensorLogic': 'Kuidas tuli võib pimeduse saabudes ise süttida',
  'game.lab.title': 'Avastuslabor',
  'game.lab.intro':
    'Lahenda meie lugude vooluringi-ülesandeid. Ühenda patareisid, lüliteid ja lampe. Aega ei mõõdeta ja punkte ei anta.',
  'game.lab.none': 'Ülesandeid pole veel avaldatud.',
  'game.lab.start': 'Alusta',
  'game.lab.challenges.one': '{count} ülesanne',
  'game.lab.challenges.other': '{count} ülesannet',
  'game.loading': 'Ülesanne laadib…',
  'game.backToLab': 'Tagasi laborisse',
  'game.part.battery': 'Patarei',
  'game.part.lamp': 'Lamp',
  'game.part.switch': 'Lüliti',
  'game.part.light-sensor': 'Valgusandur',
  'game.end.plus': '+ ots',
  'game.end.minus': '− ots',
  'game.end.left': 'vasak ots',
  'game.end.right': 'parem ots',
  'game.terminal': '{part}, {end}',
  'game.find.short-circuit':
    'Lühis! Juhe läheb +-st −-ni ilma lambita, nii et patarei läheks kuumaks. Eemalda see juhe.',
  'game.find.battery-unconnected': 'Patarei pole veel millegagi ühendatud.',
  'game.find.gap': 'Ringis on vahe. Millegagi pole ühendatud: {ends}.',
  'game.find.lamp-bypassed':
    'Juhe ühendab {lamp} mõlemad otsad, nii et elekter läheb lambist mööda, mitte läbi.',
  'game.find.switch-open': '{switches} on väljas, nii et ring on lahti.',
  'game.find.sensor-off': 'On päev, seega valgusandur ei lase elektrit läbi.',
  'game.find.hidden-fault': 'Kõik paistab ühendatud, aga miski ringis ei lase elektrit läbi.',
  'game.find.hidden-fault-tester':
    'Kõik paistab ühendatud, aga miski ringis ei lase elektrit läbi. Leia see testriga.',
  'game.find.dim': '{lamp} põleb ainult nõrgalt: see jagab patareid teise lambiga samas ringis.',
  'game.find.not-controlled-switch':
    '{lamp} põleb ka siis, kui lüliti on väljas: lüliti pole selle ringis.',
  'game.find.not-controlled-sensor': '{lamp} põleb päevavalges: valgusandur pole selle ringis.',
  'game.find.unknown': 'Veel mitte päris. Vaata lampe ja proovi uuesti.',
  'game.cond.night': 'öösel',
  'game.cond.day': 'päeval',
  'game.cond.switchOn': 'kui {switch} on sees',
  'game.cond.switchOff': 'kui {switch} on väljas',
  'game.cond.lead': '(Testitud {conditions}.)',
  'game.refused.same-terminal': 'Vali teine ots.',
  'game.refused.already-connected': 'Need kaks otsa on juba ühendatud.',
  'game.refused.no-wires-left':
    'Karbis pole enam juhtmeid. Eemalda mõni juhe, et seda uuesti kasutada.',
  'game.connected': 'Juhe ühendatud: {from} – {to}.',
  'game.selected': '{terminal} valitud. Nüüd vali, kuhu juhe läheb.',
  'game.cancelled': 'Juhe tühistatud.',
  'game.restarted': 'Laud on jälle algseisus.',
  'game.on': 'sees',
  'game.off': 'väljas',
  'game.dim': 'nõrk',
  'game.lampStatus': '{lamp}: {state}',
  'game.boardHelp':
    'Vali üks ots, siis teine, et need juhtmega ühendada (või lohista nende vahel). Esc tühistab. Klõpsa lülitit, et seda pöörata.',
  'game.shortWarning': 'Lühis! Patarei on ühendatud otse +-st −-ni.',
  'game.wiresLeft.one': 'Karbis on {count} juhe',
  'game.wiresLeft.other': 'Karbis on {count} juhet',
  'game.daylight': 'Päev või öö',
  'game.night': 'Öö',
  'game.day': 'Päev',
  'game.connections': 'Juhtmed ja osad',
  'game.connectForm': 'Ühenda kaks otsa',
  'game.from': 'Kust',
  'game.to': 'Kuhu',
  'game.connect': 'Ühenda',
  'game.noWires': 'Laual pole veel juhtmeid.',
  'game.test.ok': 'Tester piiksub: see töötab.',
  'game.test.broken': 'Piiksu pole: see on katki!',
  'game.testWire': 'Testi juhet {wire}',
  'game.testLamp': 'Testi: {lamp}',
  'game.testPart': 'Testi',
  'game.removeWire': 'Eemalda juhe {wire}',
  'game.removed': 'Juhe eemaldatud: {wire}.',
  'game.remove': 'Eemalda',
  'game.parts': 'Osad',
  'game.lampReplaced': 'Uus lamp on paigas.',
  'game.replaceLamp': 'Uus lamp',
  'game.level': '{level}. tase',
  'game.goal': 'Sinu eesmärk',
  'game.test': 'Testi vooluringi',
  'game.success': 'Said hakkama!',
  'game.attempts.one': 'Lahendatud {count} testiga.',
  'game.attempts.other': 'Lahendatud {count} testiga.',
  'game.notYet': 'Veel mitte',
  'game.noMoreHints': 'Rohkem vihjeid pole',
  'game.hint': 'Näita vihjet',
  'game.startAgain': 'Alusta uuesti',
  'game.easier': 'Proovi lihtsamat',
  'game.harder': 'Proovi raskemat',
  'game.challengeList': 'Ülesanded',
  'game.solvedMark': 'Tehtud',
  'error.GAME-CIRCUIT-001': 'Seda ülesannet ei saanud laadida. Proovi mõnda teist ülesannet.',
  'error.GAME-MISSION-001': 'See ülesanne pole saadaval. Vali laboris mõni teine.',
  'learn.why': 'Miks see ülesanne?',
  'learn.next': 'Järgmine: {title}',
  'learn.reason.start': 'Siit alustavad kõik.',
  'learn.reason.start-harder':
    'Sa ütlesid, et oled vooluringe varem teinud, seega alustad ühe sammu võrra kõrgemalt.',
  'learn.reason.step-up':
    'Sa lahendasid ülesande „{challenge}” ise, nii et siin on sama mõtte kohta raskem.',
  'learn.reason.next-idea': 'Aeg uue mõtte jaoks.',
  'learn.reason.next-idea-help':
    '„{challenge}” vajas veidi abi, nii et tuled selle mõtte juurde hiljem tagasi. Kõigepealt uus mõte.',
  'learn.reason.fast-track':
    'Sa lahendasid kaks raskemat ülesannet järjest ise, seega algab see uus mõte raskemalt tasemelt.',
  'learn.reason.step-down':
    '„{challenge}” pole veel lahendatud, nii et see lihtsam sama mõtte ülesanne võib aidata.',
  'learn.reason.try-again': '„{challenge}” pole veel lahendatud. Proovi uuesti!',
  'learn.reason.revisit': 'Tagasi mõtte juurde, mis vajas varem veidi abi.',
  'learn.reason.all-shown': 'Sa oled kõiki mõtteid ise näidanud. Vali ükskõik milline ülesanne.',
  'learn.reason.your-choice': 'Sa valisid selle ise. See on täiesti korras!',
  'learn.obj.closed-loop': 'Suletud ringid',
  'learn.obj.switch-control': 'Lülitid',
  'learn.obj.fault-diagnosis': 'Rikete leidmine',
  'learn.obj.sensor-logic': 'Valgusandur',
  'learn.status.unobserved': 'Veel proovimata',
  'learn.status.emerging': 'Algus',
  'learn.status.practised': 'Harjutatud',
  'learn.status.demonstrated': 'Ise näidatud',
  'learn.savePrompt.title': 'Kas jätta mu edusammud sellesse brauserisse meelde?',
  'learn.savePrompt.body':
    'Need salvestatakse ainult sellesse brauserisse ja neid ei saadeta meile. Saad need igal ajal kustutada jaotises „Minu andmed”.',
  'learn.savePrompt.yes': 'Jah, salvesta',
  'learn.savePrompt.no': 'Ei, aitäh',
  'learn.saving': 'Salvestan sellesse brauserisse…',
  'learn.saved': 'Sinu edusammud on salvestatud ainult sellesse brauserisse.',
  'learn.notSaved': 'Sinu edusammud püsivad ainult seni, kuni sa lehe sulged või uuesti laadid.',
  'learn.start.title': 'Kust sa tahaksid alustada?',
  'learn.start.beginning': 'Algusest',
  'learn.start.harder': 'Olen vooluringe varem teinud',
  'learn.start.note': 'Saad alati valida mõne teise ülesande.',
  'learn.progress.title': 'Mida sa oled harjutanud',
  'learn.progress.none': 'Veel pole midagi proovitud. Sinu edusammud ilmuvad siia.',
  'learn.progress.about':
    'Veel proovimata → Algus → Harjutatud → Ise näidatud. „Ise näidatud” tähendab, et lahendasid raskema ülesande kõige rohkem ühe vihje ja kolme testiga.',
  'learn.ev.solved': '„{challenge}”: lahendatud · teste: {tests} · vihjeid: {hints} · {date}',
  'learn.ev.notYet': '„{challenge}”: veel lahendamata · teste: {tests} · {date}',
  'learn.provisional.one': 'Esimene oletus {count} ülesande põhjal, mitte hinne.',
  'learn.provisional.other': 'Esimene oletus {count} ülesande põhjal, mitte hinne.',
  'learn.continue': 'Jätka: {title}',
  'error.LEARN-EVIDENCE-001':
    'Sinu edusamme ei õnnestunud sellesse brauserisse salvestada. Võid edasi mängida.',
  'ws.title': 'Meistrite õue töökoda',
  'ws.toolbar': 'Töökoja tegevused',
  'ws.save': 'Salvesta',
  'ws.open': 'Ava',
  'ws.undo': 'Võta tagasi',
  'ws.redo': 'Tee uuesti',
  'ws.export': 'Ekspordi',
  'ws.help': 'Abi',
  'ws.isSaved': 'Salvestatud sellesse brauserisse',
  'ws.unsaved': 'Veel salvestamata',
  'ws.saving': 'Salvestan…',
  'ws.inventory': 'Osad',
  'ws.addHint': 'Vali osa, et see tuppa lisada. Siis lohista seda või liiguta nooleklahvidega.',
  'ws.cat.circuit': 'Vooluringi osad',
  'ws.cat.decor': 'Toa asjad',
  'ws.add': 'Lisa: {object}',
  'ws.added': '{object} lisatud.',
  'ws.removed': '{object} eemaldatud.',
  'ws.room': 'Töökoja tuba',
  'ws.view': '3D või plaan',
  'ws.view3d': '3D',
  'ws.viewPlan': 'Plaan',
  'ws.snap': 'Joonda ruudustikuga',
  'ws.loading3d': 'Ehitan töökoda…',
  'ws.zoomIn': 'Suurenda',
  'ws.zoomOut': 'Vähenda',
  'ws.resetCamera': 'Lähtesta vaade',
  'ws.inspector': 'Omadused',
  'ws.objects': 'Asjad toas',
  'ws.empty': 'Tuba on tühi. Lisa osi vasakult nimekirjast.',
  'ws.nothingSelected': 'Midagi pole valitud. Klõpsa toas mõnel asjal või vali see siit:',
  'ws.position': 'Asukoht',
  'ws.x': 'Vasak–parem (m)',
  'ws.y': 'Kõrgus (m)',
  'ws.z': 'Ees–taga (m)',
  'ws.rotateLeft': 'Pööra vasakule',
  'ws.rotateRight': 'Pööra paremale',
  'ws.scale': 'Suurus',
  'ws.colour': 'Värv',
  'ws.caption': 'Plakati tekst',
  'ws.switch': 'Lüliti: {state}',
  'ws.threshold': 'Lülitub sisse, kui valgus on sellest tasemest väiksem',
  'ws.state': '{object}: {state}',
  'ws.wires': 'Juhtmed',
  'ws.connectTo': 'Ühenda {port} …',
  'ws.connect': 'Ühenda',
  'ws.removeWire': 'Eemalda juhe {wire}',
  'ws.wireRemoved': 'Juhe eemaldatud.',
  'ws.remove': 'Eemalda',
  'ws.duplicate': 'Kopeeri',
  'ws.deselect': 'Valmis',
  'ws.portOf': '{object}, {end}',
  'ws.wireStart': 'Juhe otsast {port}. Nüüd vali, kuhu see läheb.',
  'ws.wireDone': 'Juhe ühendatud: {from} – {to}.',
  'ws.wireCancel': 'Juhe tühistatud.',
  'ws.circuit.no-battery': 'Lisa patarei, et lambid ja ventilaatorid töötaksid.',
  'ws.circuit.several-batteries':
    'Selles töökojas saab korraga kasutada ühte patareid. Eemalda üks patarei.',
  'ws.circuit.short': 'Lühis! Juhe ühendab + ja − ilma lambi või ventilaatorita vahel.',
  'ws.circuit.ok': '{total}-st lambist ja ventilaatorist töötab {on}.',
  'ws.keys':
    'Klahvid: nooled liiguta · R pööra (Shift+R tagasi) · D kopeeri · Delete eemalda · Ctrl+Z võta tagasi · Ctrl+Y tee uuesti · Esc lõpeta',
  'ws.saveDialog': 'Salvesta oma projekt',
  'ws.name': 'Nimi',
  'ws.saveHint':
    'See salvestatakse ainult sellesse brauserisse. Ekspordi, et hoida koopiat failina.',
  'ws.saved': '„{title}” on salvestatud.',
  'ws.cancel': 'Loobu',
  'ws.close': 'Sulge',
  'ws.openDialog': 'Sinu projektid',
  'ws.newProject': 'Alusta midagi uut',
  'ws.yourProjects': 'Salvestatud projektid',
  'ws.noProjects': 'Salvestatud projekte veel pole.',
  'ws.updated': 'Uuendatud {date}',
  'ws.objectCount.one': '{count} asi',
  'ws.objectCount.other': '{count} asja',
  'ws.openProject': 'Ava',
  'ws.openNamed': 'Ava „{title}”',
  'ws.exportNamed': 'Ekspordi „{title}”',
  'ws.deleteNamed': 'Kustuta „{title}”',
  'ws.deleteProject': 'Kustuta',
  'ws.opened': '„{title}” on avatud.',
  'ws.exported': 'Sinu projektifail laaditakse alla.',
  'ws.confirmDelete': 'Kas kustutada „{title}”?',
  'ws.confirmDeleteBody':
    'See eemaldab selle brauserist. Ekspordi enne, kui tahad koopiat alles hoida.',
  'ws.continue': 'Jätka',
  'ws.discardTitle': 'Kas alustada salvestamata?',
  'ws.unreadable': 'Ühte salvestatud projekti ei saa avada',
  'ws.downloadRaw': 'Laadi see alla',
  'ws.import': 'Ava projektifail (.json)',
  'ws.leave': 'Kas lahkuda salvestamata?',
  'ws.leaveBody': 'Viimasest salvestamisest tehtud muudatused lähevad kaotsi.',
  'ws.stay': 'Jää',
  'ws.leaveConfirm': 'Lahku',
  'ws.helpTitle': 'Kuidas töökoda töötab',
  'ws.help1':
    'Lisa osi vasakult nimekirjast. Klõpsa asjal, et see valida, siis lohista, pööra või muuda seda paremal.',
  'ws.help2':
    'Vooluringi ühendamiseks klõpsa ühe osa ümaral otsal, siis teise otsal. Lamp põleb ainult siis, kui ring on suletud, täpselt nagu laboris.',
  'ws.help3':
    'Kasuta plaani, et näha tuba ülalt — see sobib hästi klaviatuuriga. Salvesta hoiab projekti selles brauseris; Ekspordi teeb faili, mida saad alles hoida.',
  'ws.storageUnavailable':
    'Selles brauseris ei saa salvestada (privaatne sirvimine või blokeeritud salvestus). Saad siiski ehitada ja eksportida.',
  'ws.dismiss': 'Selge',
  'ws.posterCaption': 'Laternatuba',
  'ws.newTitle.empty': 'Minu tuba',
  'ws.newTitle.lighthouse': 'Minu laternatuba',
  'ws.starter.empty': 'Tühi tuba',
  'ws.starter.lighthouse': 'Majaka laternatuba',
  'ws.obj.floor-tile': 'Põrandaplaat',
  'ws.obj.wall-panel': 'Seinapaneel',
  'ws.obj.table': 'Laud',
  'ws.obj.shelf': 'Riiul',
  'ws.obj.plant': 'Taim',
  'ws.obj.rug': 'Vaip',
  'ws.obj.window': 'Aken',
  'ws.obj.poster': 'Plakat',
  'ws.obj.battery': 'Patarei',
  'ws.obj.switch': 'Lüliti',
  'ws.obj.lamp': 'Lamp',
  'ws.obj.light-sensor': 'Valgusandur',
  'ws.obj.fan': 'Ventilaator',
  'ws.port.positive': '+ ots',
  'ws.port.negative': '− ots',
  'ws.port.a': 'vasak ots',
  'ws.port.b': 'parem ots',
  'ws.port.in': 'sisend',
  'ws.port.out': 'väljund',
  'ws.colour.natural': 'Puit',
  'ws.colour.sky': 'Taevasinine',
  'ws.colour.leaf': 'Lehtroheline',
  'ws.colour.sun': 'Päikesekollane',
  'ws.colour.berry': 'Marjapunane',
  'ws.colour.slate': 'Kiltkivihall',
  'ws.refused.too-many-objects': 'Tuba on täis (300 asja). Eemalda enne midagi.',
  'ws.refused.too-many-wires': 'Juhtmeid on liiga palju (300). Eemalda enne üks.',
  'ws.refused.same-port': 'Vali teine ots.',
  'ws.refused.already-connected': 'Need kaks otsa on juba ühendatud.',
  'ws.refused.unknown-object': 'Seda asja pole enam toas.',
  'ws.refused.not-a-port': 'See pole juhtme ots.',
  'ws.refused.invalid': 'Seda muudatust ei saa teha.',
  'error.WORLD-SAVE-001':
    'Seda töökoja versiooni ei saanud salvestada. Viimane salvestatud versioon on muutmata — proovi projekt eksportida.',
  'error.WORLD-SAVE-002': 'Töökoda ei saanud salvestada. Proovi enne projekt eksportida.',
  'error.WORLD-LOAD-001':
    'Seda salvestatud projekti ei saanud avada. See on alles hoitud — saad selle alla laadida või kustutada.',
  'error.WORLD-IMPORT-003':
    'See fail pole Kids Worldi projekt, mida saaksime avada. Sinu olemasolevad projektid on muutmata.',
  'help.title': 'Abi',
  'help.keyboardTitle': 'Klaviatuuri kasutamine',
  'help.keyboardBody':
    'Tab-klahviga liigud nuppude vahel ja Enter-klahviga valid. Esimene Tab-vajutus pakub valikut „Mine sisu juurde“. Escape sulgeb avanenud akna.',
  'help.broadcasterTitle': 'Ringhääling ja keel',
  'help.broadcasterBody':
    'Vali ringhääling, et näha saateid, mille selle toimetajad oma riigi jaoks valisid. Igal ringhäälingul on oma keeled. Sinu salvestatud projektid jäävad alles ka siis, kui ringhäälingut vahetad.',
  'help.fictionalTitle': 'Mida tähendab „väljamõeldud“',
  'help.fictionalBody':
    'See on prototüüp. Selle ringhäälingud, saated ja inimesed on testimiseks välja mõeldud ega esinda päris organisatsioone ega lapsi.',
  'tree.sections': 'Puumaja osad',
  'tree.whose': 'Kelle asjad on näha',
  'tree.storageUnavailable':
    'See brauser ei saa midagi salvestada (privaatne sirvimine või blokeeritud salvestus), seega pole siin salvestatud projekte ega oskusi.',
  'tree.fictionalTag': 'Väljamõeldud näidis',
  'tree.profile.sample-new-to-circuits': 'Näidisõppija: vooluringidega alles alustab',
  'tree.profile.sample-experienced': 'Näidisõppija: vooluringidega kogenud',
  'tree.profileBody.sample-new-to-circuits':
    'On proovinud esimest vooluringi-ülesannet suure abiga ja alustanud töökojas ühte tuba.',
  'tree.profileBody.sample-experienced':
    'On lahendanud raskemaid suletud ahela ja lüliti ülesandeid ning ehitanud automaatse öölambi.',
  'tree.sampleNote':
    'Sa vaatad väljamõeldud näidisõppijat, mitte päris last. See on koopia ainult selles brauseris: mida sa nüüd teed, muudab ainult seda koopiat. Sinu enda asjad jäävad alles.',
  'tree.backToOwn': 'Tagasi minu enda juurde',
  'tree.resetSample': 'Alusta seda näidist uuesti',
  'tree.removeSample': 'Eemalda see näidis',
  'tree.ownNote': 'Need on sinu enda asjad, salvestatud ainult selles brauseris.',
  'tree.trySample': 'Proovi näidisõppijat',
  'tree.trySampleBody':
    'Vaata, milline on labor ja puumaja väljamõeldud õppija jaoks. Selles brauseris tehakse privaatne koopia; keegi teine seda ei näe ja sinu enda asjad jäävad samaks.',
  'tree.useSample': 'Proovi',
  'tree.openSample': 'Ava uuesti',
  'tree.useSampleNamed': 'Proovi: {profile}',
  'tree.removeTitle': 'Eemaldada see näidisõppija?',
  'tree.removeBody':
    'Selle koopia selles brauseris koos projektide ja edusammudega kustutatakse. Uue koopia saad teha igal ajal.',
  'tree.loading': 'Laadin…',
  'tree.projectsTitle': 'Salvestatud projektid',
  'tree.noProjects': 'Midagi pole veel salvestatud. Ehita meistrite õuel midagi ja salvesta see.',
  'tree.goBuild': 'Mine meistrite õuele',
  'tree.projectsNote':
    'Projektid salvestatakse ainult selles brauseris. Brauseri andmete kustutamine eemaldab need — koopia jaoks kasuta eksporti.',
  'tree.skillsTitle': 'Vooluringi ideed',
  'tree.skillsIntro':
    'Mida labori ülesanded seni näitavad, idee kaupa. Iga rida ütleb, millisest ülesandest see tuleb.',
  'tree.builtTitle': 'Vooluringi osadega ehitatud asjad',
  'tree.notAssessed': 'Ei hinnata',
  'tree.builtNone': 'Vooluringi osadega töökoja projekte pole veel salvestatud.',
  'tree.likesTitle': 'Mis sulle meeldib',
  'tree.likesNone': 'Huvisid pole salvestatud. Neid saad valida kino otsingus.',
  'tree.futureTag': 'Tuleviku idee',
  'tree.futureCredential':
    'Tunnistused on ainult tuleviku idee. Kids World ei anna tunnistusi ega hindeid.',
  'tree.reason.no-attempts': 'Selle idee ülesannet pole veel proovitud.',
  'tree.reason.tried-not-solved': '„{challenge}“ pole veel lahendatud.',
  'tree.reason.solved-with-show-me':
    '„{challenge}“ lahendati „näita mulle“ abil, seega on see algus.',
  'tree.reason.solved-entry': '„{challenge}“ lahendati.',
  'tree.reason.solved-harder-with-help': 'Raskem ülesanne „{challenge}“ lahendati veidi abiga.',
  'tree.reason.solved-harder-independently': 'Raskem ülesanne „{challenge}“ lahendati iseseisvalt.',
  'tree.ev.solved': '„{challenge}“: lahendatud',
  'tree.ev.notYet': '„{challenge}“: veel lahendamata',
  'tree.ev.harder': 'raskem tase',
  'tree.ev.entry': 'esimene tase',
  'tree.ev.tests': 'testid: {count}',
  'tree.ev.hints': 'vihjed: {count}',
  'tree.ev.showMe': 'kasutas „näita mulle“',
  'tree.ev.ownWay': 'iseseisvalt',
  'tree.ev.chosen': 'sinu valik',
  'tree.byDay': 'Päeval: {line}',
  'tree.atNight': 'Öösel: {line}',
  'tree.sampleProject.firstRoom': 'Minu esimene tuba',
  'tree.sampleProject.nightLight': 'Öölamp',
  'shell.sampleActive': 'Väljamõeldud näidis · {profile}',
  'shell.sampleBack': 'Tagasi minu enda juurde',
  'offer.title': '{broadcaster} ei paku kohta {place}',
  'offer.body':
    'Iga ringhääling valib, milliseid kohti ta pakub. Euroopa gloobuse juures saad valida teise ringhäälingu.',
  'offer.kept': 'Kõik, mille selles brauseris salvestasid, jääb alles.',
  'offer.globe': 'Mine Euroopa gloobuse juurde',
  'offer.town': 'Tagasi linna',
  'hub.notOffered': 'Siin ei pakuta',
  'tree.samplesNotOffered': '{broadcaster} ei paku näidisõppijaid.',
  'kids.readAloud': 'Loe mulle ette',
  'kids.who.title': 'Kes mängib?',
  'kids.little': 'Ma olen väike',
  'kids.littleAges': '3–8',
  'kids.bigger': 'Ma olen suurem',
  'kids.biggerAges': '9+',
  'kids.who.say': 'Kes mängib? Puuduta jänest, kui oled väike. Puuduta raketti, kui oled suurem.',
  'kids.change': 'Muuda, kes mängib',
  'kids.town.say': 'Kuhu sa tahad minna? Puuduta pilti.',
  'time.chipLabel': 'Täna on jäänud {minutes} minutit ekraaniaega',
  'time.chip': '{minutes} min jäänud',
  'time.finish': 'Aeg on läbi — see film mängib lõpuni',
  'rest.title': 'Aeg puhata!',
  'rest.body': 'Tänane ekraaniaeg on otsas. Kohtumiseni homme!',
  'grown.button': 'Täiskasvanutele',
  'grown.title': 'Täiskasvanutele',
  'grown.hold': 'Täiskasvanud: vajutage nuppu ja hoidke 3 sekundit.',
  'grown.holdButton': 'Hoia',
  'grown.noLimit': 'Piiranguta',
  'grown.minutes': '{minutes} min',
  'grown.timeTitle': 'Tänane ekraaniaeg',
  'grown.timeIntro':
    'Kids World pakub ainult filme, mis mahuvad allesjäänud aega, ega peata ühtki poole pealt. Kui aeg on otsas, jätab see pärast filmi hüvasti.',
  'grown.used': 'Täna kasutatud: {minutes} min',
  'grown.settings': 'Ringhääling, keel ja andmed',
  'grown.save': 'Salvesta',
  'grown.close': 'Sulge',
  'room.hint.little': 'Puuduta pilti!',
  'room.hint.bigger': 'Vali film',
  'room.say': 'Sa oled kinos! Puuduta pilti, et vaadata.',
  'room.soonSay': 'Seda filmi siin veel pole.',
  'room.laterSay': 'See film on tänaseks liiga pikk. Järgmisel korral!',
  'room.back': 'Tagasi linna',
  'room.films': 'Filmid',
  'room.watch': 'Vaata: {title} ({minutes} min)',
  'room.laterLabel': '{title}: tänaseks liiga pikk',
  'room.soonLabel': '{title}: siin veel pole',
  'room.later': 'Järgmisel korral',
  'room.soon': 'Veel pole',
  'room.minutes': '{minutes} min',
  'room.play': 'Mängi',
  'room.pause': 'Paus',
  'room.stop': 'Peata film',
  'room.details': 'Filmist lähemalt',
  'room.all': 'Kõik filmid',
  'room.loading': 'Avan kino…',
};
